// src/firebase.js
// ─────────────────────────────────────────────────────────
//  הדבק כאן את ה-firebaseConfig שלך מ-Firebase Console
//  ראה הוראות ב-SETUP.md
// ─────────────────────────────────────────────────────────
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey:            "AIzaSyDzgzfx5q9EgrZtES0i6VmA0wf6CKaXewQ",
  authDomain:        "moti-kitchen-project.firebaseapp.com",
  projectId:         "moti-kitchen-project",
  storageBucket:     "moti-kitchen-project.firebasestorage.app",
  messagingSenderId: "300164541979",
  appId:             "1:300164541979:web:57446a57a49f0e839792be",
};

const app     = initializeApp(firebaseConfig);
export const db      = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
